import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Account } from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'

export const accountsMounted = createEvent()

export const setAccountsRequestError = createEvent<RequestError>()

export const getAccounts = fx<void, Account[]>({
  method: 'GET',
  url: '/client/{clientId}/accounts',
})

export const $accounts = restore<Account[]>(
  getAccounts.doneData.map((doneData) => doneData.body),
  [],
)

export const $errorAccountsRequest = restore(setAccountsRequestError, {
  message: '',
  code: 0,
})

sample({
  clock: [accountsMounted],
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.clientID
    }
    return {
      query: {
        populate: JSON.stringify([
          'Account',
          'Account.strategy',
          'Account.subscriptions',
        ]),
      },
      url: `/client/${id}/accounts`,
    }
  },
  target: [getAccounts],
})

sample({
  clock: getAccounts.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setAccountsRequestError],
})
